export default {
  'logo.name': 'BasetaoSheet',
  'logo.tagline': 'Centro de recursos',

  'meta.title': 'Hoja Basetao: productos, vendedores y guías de compra',
  'meta.description': 'Explora recursos de la hoja Basetao, hallazgos de productos, guías de vendedores, consejos QC, información de envío y guías de compra.',

  'nav.spreadsheet': 'Hoja de cálculo',
  'nav.home': 'Inicio',
  'nav.guide': 'Guía de compra',
  'nav.guides': 'Guías',
  'nav.products': 'Productos',
  'nav.sellers': 'Vendedores',
  'nav.qc': 'Control de calidad',
  'nav.shipping': 'Envío',
  'nav.reviews': 'Reseñas',
  'nav.safety': 'Seguridad',
  'nav.cta': 'Explorar la hoja',

  'hero.eyebrow': 'EL CENTRO DE RECURSOS DE LA HOJA BASETAO',
  'hero.title': 'Hoja de cálculo Basetao — Encuentra productos, vendedores y guías de compra más rápido',
  'hero.subtitle': 'Explora recursos organizados de la hoja Basetao, hallazgos de productos, información de vendedores, guías de control de calidad, consejos de envío y tutoriales prácticos — todo en un solo lugar.',
  'hero.ctaPrimary': 'Hoja Basetao',
  'hero.ctaSecondary': 'Comprar ahora',
  'hero.dropdownLabel': 'Explorar una categoría',
  'hero.dropdownPlaceholder': 'Elige una categoría de producto…',
  'hero.trust': 'Recurso independiente · Guías actualizadas · Investigación de productos y vendedores · Control de calidad y envío',

  'value.title': 'Todo lo que necesitas para navegar Basetao',
  'value.subtitle': 'Un punto de partida claro y organizado para descubrir productos de forma más inteligente.',
  'value.c1.title': 'Hoja Basetao',
  'value.c1.desc': 'Descubre recursos organizados y aprende a evaluar la información de productos y vendedores.',
  'value.c2.title': 'Guías de productos y vendedores',
  'value.c2.desc': 'Compara productos, vendedores, precios y las señales importantes antes de pedir.',
  'value.c3.title': 'Control de calidad',
  'value.c3.desc': 'Comprende las fotos QC, los indicadores de calidad y qué verificar antes de pedir.',
  'value.c4.title': 'Envío y seguridad',
  'value.c4.desc': 'Compara opciones y costes de envío, y aprende a detectar riesgos y anuncios sospechosos.',

  'categories.title': 'Explorar categorías de productos',
  'categories.subtitle': 'Salta directo a una categoría de la tienda principal y empieza a explorar hallazgos organizados.',
  'categories.open': 'Abrir categoría',

  'about.eyebrow': '¿QUÉ ES UNA HOJA BASETAO?',
  'about.title': 'Una forma más inteligente de encontrar productos y vendedores',
  'about.body1': 'Una hoja Basetao es un documento compartido y organizado que reúne enlaces de productos, detalles de vendedores, precios y notas del ecosistema del agente de compras Basetao. En lugar de desplazarse por listados interminables, los compradores usan estas hojas para comparar opciones una al lado de la otra y entender exactamente qué compran.',
  'about.body2': 'La mayoría de las hojas se organizan por categoría — zapatos, sudaderas, camisetas, chaquetas, bolsos y más — y cada fila suele apuntar a un producto o vendedor con contexto extra como precio, notas de talla y observaciones de control de calidad.',
  'about.body3': 'Como estos documentos se actualizan con regularidad, son un atajo práctico para descubrir artículos nuevos y vendedores de confianza sin pasar horas navegando por marketplaces.',
  'about.list1': 'Enlaces de productos seleccionados',
  'about.list2': 'Señales de vendedores y precios',
  'about.list3': 'Actualizaciones periódicas',

  'how.title': 'Cómo usar una hoja Basetao',
  'how.subtitle': 'Cuatro pasos sencillos para sacar valor real de cualquier hoja.',
  'how.s1.title': 'Descubrir',
  'how.s1.desc': 'Encuentra productos y categorías relevantes que coincidan con lo que buscas.',
  'how.s2.title': 'Comparar',
  'how.s2.desc': 'Revisa la información de producto, vendedor y precio una al lado de la otra.',
  'how.s3.title': 'Verificar',
  'how.s3.desc': 'Comprueba enlaces, señales de vendedores e información de control de calidad disponible.',
  'how.s4.title': 'Decidir',
  'how.s4.desc': 'Usa la información para tomar tu propia decisión informada.',

  'topics.title': 'Recursos populares de Basetao',
  'topics.subtitle': 'Guías y recursos para comprar con más confianza.',
  'topics.cardTitle': 'Guía de la hoja Basetao',
  'topics.cardDesc': 'Aprende qué es una hoja Basetao, cómo leerla y cómo usarla para encontrar mejores productos y vendedores.',
  'topics.readMore': 'Leer la guía',
  'topics.moreComing': 'Más guías próximamente',
  'guide.notFound': 'No se encontró esta guía.',

  'faq.title': 'Preguntas frecuentes sobre la hoja Basetao',
  'faq.q1': '¿Qué es una hoja Basetao?',
  'faq.a1': 'Es un documento organizado que reúne enlaces de productos, información de vendedores, precios y notas del ecosistema Basetao para comparar y descubrir con más facilidad.',
  'faq.q2': '¿La hoja es gratuita?',
  'faq.a2': 'Los recursos de la hoja son informativos. Verifica siempre la fuente y los enlaces antes de comprar.',
  'faq.q3': '¿Con qué frecuencia se actualiza la hoja?',
  'faq.a3': 'Depende de la fuente. Las hojas fiables suelen actualizarse con regularidad a medida que se añaden productos y vendedores.',
  'faq.q4': '¿Puedo confiar en todos los vendedores listados?',
  'faq.a4': 'Ningún recurso puede garantizar un vendedor. Usa varias señales — reseñas, fotos QC e información de envío — antes de decidir.',
  'faq.q5': '¿Qué categorías suelen incluirse?',
  'faq.a5': 'Las categorías habituales incluyen zapatos, sudaderas, camisetas, chaquetas, pantalones, gorros, conjuntos, ropa interior, camisetas deportivas, accesorios, bolsos, cinturones, perfumes y más.',

  'cta.title': '¿Listo para explorar los recursos de la hoja Basetao?',
  'cta.subtitle': 'Explora las últimas guías, recursos de productos e información de compra en un hub organizado.',
  'cta.button': 'Explorar la hoja Basetao',

  'footer.tagline': 'Un centro de recursos independiente para guías de la hoja Basetao, hallazgos de productos e información de compra.',
  'footer.disclaimer': 'Este sitio web es un recurso informativo independiente. No está afiliado ni respaldado por Basetao.',
  'footer.navTitle': 'Explorar',
  'footer.resourceTitle': 'Recursos',
  'footer.copyright': 'Todos los derechos reservados.',

  'cat.shoes': 'Zapatos',
  'cat.hoodies': 'Sudaderas / Jerséis',
  'cat.tshirts': 'Camisetas',
  'cat.jackets': 'Chaquetas',
  'cat.pants': 'Pantalones / Cortos',
  'cat.headwear': 'Gorros',
  'cat.sets': 'Conjuntos',
  'cat.underwear': 'Ropa interior',
  'cat.jersey': 'Camisetas deportivas',
  'cat.accessories': 'Accesorios',
  'cat.bags': 'Bolsos',
  'cat.belts': 'Cinturones',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Otros artículos',
};